/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AdminAgenda from './pages/AdminAgenda';
import AdminAvaliacoes from './pages/AdminAvaliacoes';
import AdminBanners from './pages/AdminBanners';
import AdminComunicacao from './pages/AdminComunicacao';
import AdminCultos from './pages/AdminCultos';
import AdminDashboard from './pages/AdminDashboard';
import AdminGaleria from './pages/AdminGaleria';
import AdminGrupos from './pages/AdminGrupos';
import AdminIgreja from './pages/AdminIgreja';
import AdminInscricoes from './pages/AdminInscricoes';
import AdminLideres from './pages/AdminLideres';
import AdminMembros from './pages/AdminMembros';
import AdminMinisterios from './pages/AdminMinisterios';
import AdminOracoes from './pages/AdminOracoes';
import AdminPermissoes from './pages/AdminPermissoes';
import AdminQRCodeMBV from './pages/AdminQRCodeMBV';
import AdminRoles from './pages/AdminRoles';
import AdminRankingMBV from './pages/AdminRankingMBV';
import AdminUserRoles from './pages/AdminUserRoles';
import AdminVideos from './pages/AdminVideos';
import Agenda from './pages/Agenda';
import Avaliacoes from './pages/Avaliacoes';
import Biblia from './pages/Biblia';
import Avisos from './pages/Avisos';
import CadastroMembro from './pages/CadastroMembro';
import CartaoMembro from './pages/CartaoMembro';
import CalendarioDisponibilidade from './pages/CalendarioDisponibilidade';
import CalendarioDisponibilidadeKidsMBV from './pages/CalendarioDisponibilidadeKidsMBV';
import CalendarioDisponibilidadeDanca from './pages/CalendarioDisponibilidadeDanca';
import CalendarioDisponibilidadeMidia from './pages/CalendarioDisponibilidadeMidia';
import CalendarioDisponibilidadeRecepcao from './pages/CalendarioDisponibilidadeRecepcao';
import CalendarioGrupo from './pages/CalendarioGrupo';
import CalendarioIntegrado from './pages/CalendarioIntegrado';
import Doacoes from './pages/Doacoes';
import EditarPerfil from './pages/EditarPerfil';
import EquipeKidsMBV from './pages/EquipeKidsMBV';
import EquipeDanca from './pages/EquipeDanca';
import EquipeLouvor from './pages/EquipeLouvor';
import EquipeMidia from './pages/EquipeMidia';
import EquipeRecepcao from './pages/EquipeRecepcao';
import EscalasKidsMBV from './pages/EscalasKidsMBV';
import EscalasDanca from './pages/EscalasDanca';
import EscalasLouvor from './pages/EscalasLouvor';
import EscalasMidia from './pages/EscalasMidia';
import EscalasRecepcao from './pages/EscalasRecepcao';
import Galeria from './pages/Galeria';
import Grupos from './pages/Grupos';
import Hinos from './pages/Hinos';
import Home from './pages/Home';
import InscricaoEvento from './pages/InscricaoEvento';
import IntegrantesKidsMBV from './pages/IntegrantesKidsMBV';
import IntegrantesDanca from './pages/IntegrantesDanca';
import IntegrantesLouvor from './pages/IntegrantesLouvor';
import IntegrantesMidia from './pages/IntegrantesMidia';
import IntegrantesRecepcao from './pages/IntegrantesRecepcao';
import Localizacao from './pages/Localizacao';
import Mensagens from './pages/Mensagens';
import NossosCultos from './pages/NossosCultos';
import PedidoOracao from './pages/PedidoOracao';
import Perfil from './pages/Perfil';
import QuemSomos from './pages/QuemSomos';
import RankingMBV from './pages/RankingMBV';
import Relatorios from './pages/Relatorios';
import StaffCulto from './pages/StaffCulto';
import Transmissao from './pages/Transmissao';
import Videos from './pages/Videos';
import __Layout from './Layout.jsx';


export const PAGES = {
    "AdminAgenda": AdminAgenda,
    "AdminAvaliacoes": AdminAvaliacoes,
    "AdminBanners": AdminBanners,
    "AdminComunicacao": AdminComunicacao,
    "AdminCultos": AdminCultos,
    "AdminDashboard": AdminDashboard,
    "AdminGaleria": AdminGaleria,
    "AdminGrupos": AdminGrupos,
    "AdminIgreja": AdminIgreja,
    "AdminInscricoes": AdminInscricoes,
    "AdminLideres": AdminLideres,
    "AdminMembros": AdminMembros,
    "AdminMinisterios": AdminMinisterios,
    "AdminOracoes": AdminOracoes,
    "AdminPermissoes": AdminPermissoes,
    "AdminQRCodeMBV": AdminQRCodeMBV,
    "AdminRoles": AdminRoles,
    "AdminRankingMBV": AdminRankingMBV,
    "AdminUserRoles": AdminUserRoles,
    "AdminVideos": AdminVideos,
    "Agenda": Agenda,
    "Avaliacoes": Avaliacoes,
    "Biblia": Biblia,
    "Avisos": Avisos,
    "CadastroMembro": CadastroMembro,
    "CartaoMembro": CartaoMembro,
    "CalendarioDisponibilidade": CalendarioDisponibilidade,
    "CalendarioDisponibilidadeKidsMBV": CalendarioDisponibilidadeKidsMBV,
    "CalendarioDisponibilidadeDanca": CalendarioDisponibilidadeDanca,
    "CalendarioDisponibilidadeMidia": CalendarioDisponibilidadeMidia,
    "CalendarioDisponibilidadeRecepcao": CalendarioDisponibilidadeRecepcao,
    "CalendarioGrupo": CalendarioGrupo,
    "CalendarioIntegrado": CalendarioIntegrado,
    "Doacoes": Doacoes,
    "EditarPerfil": EditarPerfil,
    "EquipeKidsMBV": EquipeKidsMBV,
    "EquipeDanca": EquipeDanca,
    "EquipeLouvor": EquipeLouvor,
    "EquipeMidia": EquipeMidia,
    "EquipeRecepcao": EquipeRecepcao,
    "EscalasKidsMBV": EscalasKidsMBV,
    "EscalasDanca": EscalasDanca,
    "EscalasLouvor": EscalasLouvor,
    "EscalasMidia": EscalasMidia,
    "EscalasRecepcao": EscalasRecepcao,
    "Galeria": Galeria,
    "Grupos": Grupos,
    "Hinos": Hinos,
    "Home": Home,
    "InscricaoEvento": InscricaoEvento,
    "IntegrantesKidsMBV": IntegrantesKidsMBV,
    "IntegrantesDanca": IntegrantesDanca,
    "IntegrantesLouvor": IntegrantesLouvor,
    "IntegrantesMidia": IntegrantesMidia,
    "IntegrantesRecepcao": IntegrantesRecepcao,
    "Localizacao": Localizacao,
    "Mensagens": Mensagens,
    "NossosCultos": NossosCultos,
    "PedidoOracao": PedidoOracao,
    "Perfil": Perfil,
    "QuemSomos": QuemSomos,
    "RankingMBV": RankingMBV,
    "Relatorios": Relatorios,
    "StaffCulto": StaffCulto,
    "Transmissao": Transmissao,
    "Videos": Videos,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};
